import React from "react";
import "./Typography.css";

const Typography = ({ children, color, size, txtStyle, center, className }) => {
  return (
    <div
      className={`typography txt-${color} txt-${size} txt-${txtStyle} ${
        center && "txt-center"
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Typography;
